import * as React from 'react';
export const CnTabContext = React.createContext({
    activeKey: -1,
    fullWidth: true,
    change: () => { },
});
